<form class="form-popup" [formGroup]="formGroup">

  <div class="modal-header">
    <b>Enter Revoke Reason for Qual Task: {{qthDesc}}</b>
  </div>

  <div class="row top10 no-gutters">
    <div class="col-xs-3 text-right">
      Comment:&nbsp;&nbsp;
    </div>
    <div class="col-xs-9">
      <mat-form-field appearance="fill" class="editable-text-field">
        <textarea matInput rows="6" formControlName="revokeComment" > </textarea>
      </mat-form-field>
    </div>
  </div>

  	<div class="row top10 no-gutters">
    <div class="col-xs-3 text-right">
      Send Email:&nbsp;&nbsp;
    </div>
    <div class="col-xs-9">
      <input style="width: 13px" type="checkbox" formControlName="sendRevokeEmail" />
    </div>
  </div>
</form>
